import { Button, Grid, Typography } from '@mui/material';
import { deDE, GridColDef } from '@mui/x-data-grid';
import { IAssetCategoryId } from '../../../../../../Interfaces/Asset/IAssetCategory';
import { IAssetTypeId } from '../../../../../../Interfaces/Asset/IAssetType';
import { IOtherAsset } from '../../../../../../Interfaces/Asset/IOtherAsset';
import { CrudDataGrid } from '../../../generic/CrudDataGrid';

type OtherAssetsSectionProps = {
  assets: IOtherAsset[];
  handleOpen: (
    assetCategoryId: IAssetCategoryId,
    assetTypeId?: IAssetTypeId,
    assetId?: number
  ) => void;
  handleDelete: (assetId: number) => void;
};

const columns: GridColDef<IOtherAsset, any, any>[] = [
  { field: 'name', headerName: 'Name', width: 150 },
  {
    field: 'notes',
    headerName: 'Beschreibung',
    valueGetter: params => params.row.data.notes,
    flex: 1,
  },
];

export function OtherAssetsSection({
  assets,
  handleOpen,
  handleDelete,
}: OtherAssetsSectionProps) {
  return (
    <>
      <Grid item xs={6}>
        <Typography variant='h4' sx={{ mb: 3 }}>
          Sonstige Vermögenswerte
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Button
          sx={{ float: 'right' }}
          variant='contained'
          onClick={() => handleOpen(IAssetCategoryId.Other)}
        >
          Sonstige Vermögenswerte hinzufügen
        </Button>
      </Grid>

      <Grid item xs={12}>
        <CrudDataGrid<IOtherAsset>
          sx={{ mt: 2 }}
          autoHeight
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={assets}
          columns={columns}
          getRowId={row => row.idAsset}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          onClickEdit={(assetId, assetRow) => {
            handleOpen(
              IAssetCategoryId.Other,
              assetRow.idAssetType,
              Number(assetId)
            );
          }}
          onClickDelete={assetId => {
            handleDelete(Number(assetId));
          }}
        />
      </Grid>
    </>
  );
}
